export const DEFAULT_LANGUAGE = "en";

export const SUPPORTED_LANGUAGES = [
  {
    code: "en",
    label: "English",
    nativeLabel: "English",
    rtl: false,
    enabled: true
  },
  {
    code: "es",
    label: "Spanish",
    nativeLabel: "Español",
    rtl: false,
    enabled: true
  },
  {
    code: "zh-Hans",
    label: "Chinese Simplified",
    nativeLabel: "简体中文",
    rtl: false,
    enabled: false // not needed yet — enable after translations are reviewed
  }, 
  {
    code: "id",
    label: "Indonesian",
    nativeLabel: "Bahasa Indonesia",
    rtl: false,
    enabled: false // not needed yet — enable after translations are reviewed
  }
];

export const isSupportedLanguage = (code) =>
  SUPPORTED_LANGUAGES.some((language) => language.code === code && language.enabled);

export const getLanguageDirection = (code) =>
  SUPPORTED_LANGUAGES.find((language) => language.code === code)?.rtl ? "rtl" : "ltr";